import React, { useEffect, useState, useContext } from 'react'
import { language } from '../../App'
import './ProductionService.scss'
import ServiceGrid from '../../components/ServiceGrid/ServiceGrid'
import Services from '../../components/Services/Services'
import { Fetcher } from '../../helpers/api/Fetcher'
import H1 from '../../components/Fonts/H1/H1';
import { Col, Container, Row } from 'react-bootstrap';

const ProductionService = () => {
  const { currentLanguage } = useContext(language)
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState([])

  useEffect(() => {
    const fecthApi = async () => {
      const URL = `https://beta.haromstudio.hu/scriptedprod/wp-json/wp/v2/production-service?_embed&acf_format=standard&lang=${currentLanguage}`;
      const res = await Fetcher({ URL, setIsLoading })
      setData(res)
      
      setIsLoading(false)
    }
    
    fecthApi()
  }, [currentLanguage])

  if (!isLoading && data) {
  return (
    <main className='production-service'>
        <Container>
          <Row className='mt-4'>
            <Col xs={12}>
              <div className='block block-site-title mt-2'>
                <H1 text='Your next service partner in Budapest' />
              </div>
            </Col>
          </Row>
        </Container>

        <Container>
          <Row>
            <Col xs={12}>
              {!isLoading && <ServiceGrid data={data}/>}
            </Col>
          </Row>
        </Container>
        <Container>
          <Row>
            <Col xs={12}>
              {!isLoading && <Services data={data}/>}
            </Col>
          </Row>
        </Container>
    </main>
  )
  } else {
    return (
      <main className='body'></main>
    )
  }
}

export default ProductionService